import { getEventLocationIfURL } from 'features/meetings'

import { useNotetaker } from './add_notetaker_button'
import { getShowReschedule } from './utils'

/**
 * Shared hook for in-progress reschedule placement.
 * Use in InProgressMeetingActions and MoreActions so reschedule shows in the row
 * vs dropdown consistently (row when Add Notetaker isn't visible, dropdown when it is).
 * When there is no eventLocation (no Join button), reschedule always shows in the row
 * since there is room for both Reschedule and Add Notetaker.
 *
 * @param {Object} event - Meeting event
 * @param {boolean} inProgress - Whether the meeting is currently in progress
 * @returns {{ showRescheduleInRow: boolean, showRescheduleInDropdown: boolean }}
 */
export const useRescheduleVisibility = (event, inProgress = false) => {
  const { canAdd: canAddNotetaker, notetakerAdded } = useNotetaker()
  const addNotetakerButtonVisible = canAddNotetaker && !notetakerAdded
  const showReschedule = getShowReschedule(event)
  const eventLocation = getEventLocationIfURL(event?.location)

  // When no Join button (no eventLocation), there's room for Reschedule + Add Notetaker in row
  const showRescheduleInRow = showReschedule && (!addNotetakerButtonVisible || !eventLocation)
  const showRescheduleInDropdown = inProgress && showReschedule && !showRescheduleInRow

  return { showRescheduleInRow, showRescheduleInDropdown }
}
